import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import API_URL from '../constants/environment';

interface CreateOrganizationInput {
    name: string;
    orgType: 'mso' | 'sso' | 'franchise';
    organizationMode?: 'full-time' | 'invoicing' | 'inventory';
    adminEmail: string
}

interface CreateOrganizationResponse {
    organizationId: string;
    name: string;
}

export const useCreateOrganization = () => {
    const createOrganization = async (input: CreateOrganizationInput): Promise<AxiosResponse<CreateOrganizationResponse>> => {
        return axios.post(`${API_URL}/settings/organizations/create`, input);
    };

    return useMutation({
        mutationFn: createOrganization,
    });
};